// extracted by mini-css-extract-plugin
export var container = "_hi-0";
export var content = "_hi-3";
export var customerTitle = "_hi-4";
export var empty = "_hi-5";
export var gray = "_hi-6";
export var header = "_hi-7";
export var info = "_hi-8";
export var loading = "_hi-2";
export var loadingCard = "_hi-9";
export var oneLine = "_hi-a";
export var personName = "_hi-e";
export var pillContainer = "_hi-b";
export var selected = "_hi-1";
export var text = "_hi-c";
export var twoLines = "_hi-d";
export var unread = "_hi-f";
export var unreadIndicator = "_hi-g";